import React from 'react';
import _ from 'lodash';

import './Hero.css';

const imgLogo = <img src="/images/svg/logo.svg" alt="Vespa" style={{ width: '350px' }} />;
const imgVespa = <img src="/images/svg/vespa.svg" alt="Vespa" style={{ width: '600px' }} />;

const imgLogoSource = [imgLogo, imgVespa];
const imgHero = _.sample(imgLogoSource);

const Hero = props => (
  <section
    className="u-py-100 u-h-100vh u-flex-center"
    style={{
      // background: "url('assets/img/app/intro-hero.jpg') no-repeat",
      background: "url('images/bg/intro-hero-2.jpg') no-repeat",
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    }}
  >
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 mt-5">
          <h1 className="display-3 u-fw-600 text-white">{props.hero.title}</h1>
          <p className="u-fs-22 text-white u-lh-1_7 u-py-40" dangerouslySetInnerHTML={{ __html: props.hero.desc }}>
            {/* {props.hero.desc} */}
          </p>
          {/* <span className="osa">
            <img src="/images/svg/osa.svg" alt="Vespa" />{' '}
          </span>
          <a href="#map" className="btn btn btn-rounded btn-white ml-3">
            VIDIMO SE NA SUSRETU!!!
          </a> */}
        </div>

        <div className="col-lg-6 ml-auto text-center mt-5">
          <span className="vespa d-none d-sm-block">{imgHero}</span>
        </div>
      </div>
    </div>

    <div className="u-pos-abs u-bottom-0 u-z-index-minus-1 u-left-0">
      <img src="assets/img/app/curve.png" alt="" />
    </div>
  </section>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js